import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import { TermItem } from '../../../../../graphql/graphql';
import { NcziSetupInsuranceSettings } from '../NcziSetupSettings';

interface Props {
	onSubmit: (values: NCZISetupInsuranceCompanyValues) => void;
	insuranceCompany: TermItem;
	currentSettings: NcziSetupInsuranceSettings | null
}

export interface NCZISetupInsuranceCompanyValues {
	codeDoctor: string,
	codeNZ: string,
	companyIdentificationNumber: string,
	username: string,
	password: string
}

const NCZISetupInsuranceCompany: React.FC<Props> = ({ onSubmit, insuranceCompany, currentSettings }) => {
	const formMethods = useForm({
		defaultValues: {
			codeDoctor: currentSettings?.codeDoctor,
			codeNZ: currentSettings?.codeNZ,
			companyIdentificationNumber: currentSettings?.companyIdentificationNumber,
			username: currentSettings?.username
		}
	})

	const handleSubmit = (values: NCZISetupInsuranceCompanyValues) => {
		if(!values.password) {
			values.password = currentSettings?.password || '';
		}

		onSubmit(values);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<InputField name='codeDoctor' label='Kód lékaře' />
			</InputWrapper>
			<InputWrapper>
				<InputField name='codeNZ' label='NZ kód' />
			</InputWrapper>
			<InputWrapper>
				<InputField name='companyIdentificationNumber' label='IČO' />
			</InputWrapper>
			<InputWrapper>
				<InputField name='username' label='Uživatelské jméno' />
			</InputWrapper>
			<InputWrapper>
				<InputField name='password' type='password' label='Heslo' />
			</InputWrapper>
			<InputWrapper>
				<SubmitButton onSubmit={handleSubmit} title={'component.nczi.setup.save'} />
			</InputWrapper>
		</FormWrapper>
	);
};

export default NCZISetupInsuranceCompany;
